// extracted by mini-css-extract-plugin
export default {"root":"distribute-sides-list_root__MR5jj","item":"distribute-sides-list_item__3CV8k"};